import styled, {css} from 'styled-components'
import {Modal, ModalHeader} from '@components/ui/modal-atoms/ModalAtoms.tsx'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'

export const StyledModal = styled(Modal)(
    ({theme: {spacing}}) => css`
        top: ${spacing * 5}px;
        bottom: ${spacing * 5}px;
        right: ${spacing * 5}px;
        left: unset;
        transform: unset;
        display: grid;
        grid-template-rows: auto minmax(0, 1fr) auto;
        max-height: unset;
    `
)

export const StyledModalHeader = styled(ModalHeader)(
    ({theme: {spacing}}) => css`
        display: flex;
        flex-direction: column;
        gap: ${spacing * 4}px;
    `
)

export const StyledModalTitle = styled.h3(
    ({theme: {typography}}) => css`
        ${typography.textXl};
        font-weight: 500;
    `
)

export const StyledActiveCard = styled.div(
    ({theme: {palette, spacing, typography}}) => css`
        background-color: ${palette.neutral['50']};
        border: 1px solid ${palette.neutral['200']};
        display: flex;
        flex-direction: column;
        gap: ${spacing * 0.5}px;
        border-radius: 6px;
        padding: ${spacing * 3}px;

        & h3 {
            ${typography.textMd};
            font-weight: 500;
        }
        & p {
            ${typography.textSm};
        }
    `
)

export const StyledDoctorTherapistControls = styled(Flexbox)(
    ({theme: {palette, spacing, opacities}}) => css`
        position: sticky;
        top: 0;
        background-color: ${palette.neutral['white']}${opacities['80']};
        padding-top: ${spacing * 4}px;
        backdrop-filter: blur(5px);
    `
)
